// extracted by mini-css-extract-plugin
export default {"fav":"styles_fav__wYcK5","titleWrapper":"styles_titleWrapper__cgXza","title":"styles_title__e0W-E","favList":"styles_favList__dEkxI"};